"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));
var _RoomCard = require("./RoomCard.propTypes");
var _loadableComponents = _interopRequireDefault(require("loadable-components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || (0, _typeof2.default)(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PriceInfo = (0, _loadableComponents.default)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require( /* webpackChunkName:"PriceInfo" */"./PriceInfo"));
  });
});
var OptionsAndBenefitsInfo = (0, _loadableComponents.default)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require( /* webpackChunkName:"OptionsAndBenefitsInfo" */"./OptionsAndBenefitsInfo"));
  });
});
var RateContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "RateInfo__RateContentWrapper",
  componentId: "sc-51zx10-0"
})(["background-color:", ";display:flex;flex-direction:row;border-bottom:2px solid #f8f8f8;"], function (_ref) {
  var theme = _ref.theme;
  return theme.backgroundColor.default;
});
var PriceInfoWrapper = _styledComponents.default.div.withConfig({
  displayName: "RateInfo__PriceInfoWrapper",
  componentId: "sc-51zx10-1"
})(["margin-left:auto;display:flex;align-items:flex-end;"]);
var RateInfo = function RateInfo(_ref2) {
  var _bedGroups$0$token, _bedGroups$;
  var isShowRateName = _ref2.isShowRateName,
    theme = _ref2.theme,
    rate = _ref2.rate,
    index = _ref2.index,
    _ref2$translations = _ref2.translations,
    translations = _ref2$translations === void 0 ? {} : _ref2$translations,
    onSelectRoomHandler = _ref2.onSelectRoomHandler,
    locale = _ref2.locale,
    isSingleOption = _ref2.isSingleOption,
    promoTitle = _ref2.promoTitle,
    discountType = _ref2.discountType,
    applyBigpoints = _ref2.applyBigpoints,
    bigMembership = _ref2.bigMembership,
    isSnap = _ref2.isSnap,
    includedInPriceHeader = _ref2.includedInPriceHeader,
    roomAmenity = _ref2.roomAmenity,
    roomAmenityName = _ref2.roomAmenityName,
    withTooltip = _ref2.withTooltip,
    soldOutBedGroupTokens = _ref2.soldOutBedGroupTokens,
    lowInventoryFOMO = _ref2.lowInventoryFOMO,
    isBogoPromoEnabled = _ref2.isBogoPromoEnabled,
    bogoMessage = _ref2.bogoMessage,
    bogoTag = _ref2.bogoTag,
    payNowMessage = _ref2.payNowMessage,
    isPayNowEnabled = _ref2.isPayNowEnabled,
    move = _ref2.move,
    isRM9PromoEnabled = _ref2.isRM9PromoEnabled,
    accessible = _ref2.accessible,
    getTranslatedPricebreakdownData = _ref2.getTranslatedPricebreakdownData,
    enableCombosavingsTag = _ref2.enableCombosavingsTag,
    bundleSavingsTag = _ref2.bundleSavingsTag,
    totalSummaryPax = _ref2.totalSummaryPax,
    isMobile = _ref2.isMobile,
    orText = _ref2.orText,
    enableInstallmentOption = _ref2.enableInstallmentOption,
    isBlockedRateIsEnabled = _ref2.isBlockedRateIsEnabled;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var rateName = rate.rateName,
    discountText = rate.discountText,
    strikeThrough = rate.strikeThrough,
    strikethroughPrice = rate.strikethroughPrice,
    totalPrice = rate.totalPrice,
    CTAButtonText = rate.CTAButtonText,
    cancellationPenaltyType = rate.cancellationPenaltyType,
    freeCancellationText = rate.freeCancellationText,
    toolTipCancellationHeaderText = rate.toolTipCancellationHeaderText,
    toolTipCancellationBodyText = rate.toolTipCancellationBodyText,
    refundable = rate.refundable,
    price = rate.price,
    perPersonBaseRate = rate.perPersonBaseRate,
    payLaterText = rate.payLaterText,
    payAtHotelText = rate.payAtHotelText,
    payLater = rate.payLater,
    instantConfirmationText = rate.instantConfirmationText,
    nonRefundableText = rate.nonRefundableText,
    payAtHotel = rate.payAtHotel,
    amenities = rate.amenities,
    partiallyRefundableText = rate.partiallyRefundableText,
    recommendedText = rate.recommendedText,
    flierDiscountText = rate.flierDiscountText,
    baseRate = rate.baseRate,
    baseRateAfterBigPointsDeduction = rate.baseRateAfterBigPointsDeduction,
    totalPayable = rate.totalPayable,
    perGuestText = rate.perGuestText,
    snapPriceText = rate.snapPriceText,
    includeTaxText = rate.includeTaxText,
    bigPoint = rate.bigPoint,
    bedGroupsOptions = rate.bedGroupsOptions,
    isFreeCancellation = rate.isFreeCancellation,
    isNonRefundable = rate.isNonRefundable,
    isPayAtHotel = rate.isPayAtHotel,
    isPayLater = rate.isPayLater,
    refundType = rate.refundType,
    bedGroups = rate.bedGroups,
    savingsAmount = rate.savingsAmount,
    totalInclusivePrice = rate.totalInclusivePrice,
    installmentPaymentData = rate.installmentPaymentData,
    isBlockedRate = rate.isBlockedRate;
  var secondNight = rate === null || rate === void 0 ? void 0 : rate.second_night;
  var token = (_bedGroups$0$token = bedGroups === null || bedGroups === void 0 || (_bedGroups$ = bedGroups[0]) === null || _bedGroups$ === void 0 ? void 0 : _bedGroups$.token) !== null && _bedGroups$0$token !== void 0 ? _bedGroups$0$token : null;
  var isSoldOut = soldOutBedGroupTokens === null || soldOutBedGroupTokens === void 0 ? void 0 : soldOutBedGroupTokens.includes(token);
  if (isBlockedRate && isBlockedRateIsEnabled) {
    isSoldOut = true;
  }
  if (totalPayable) {
    Object.assign(totalPayable, {
      text: totalPrice.text
    });
  }
  var freeCancellation = translations.freeCancellation,
    nonRefundable = translations.nonRefundable,
    partiallyRefundable = translations.partiallyRefundable,
    perNight = translations.perNight,
    perGuest = translations.perGuest,
    option = translations.option,
    messageFOMO = translations.messageFOMO,
    soldOutCTA = translations.soldOutCTA;
  var newTextButtonCTA = isSoldOut ? soldOutCTA : CTAButtonText;
  var onSelectRateHandler = function onSelectRateHandler() {
    onSelectRoomHandler(rate);
  };
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(RateContentWrapper, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginRight: '-200px'
      }
    }, /*#__PURE__*/_react.default.createElement(OptionsAndBenefitsInfo, {
      rateName: rateName,
      isShowRateName: isShowRateName,
      index: index,
      option: option,
      theme: theme,
      toolTipCancellationHeaderText: toolTipCancellationHeaderText,
      toolTipCancellationBodyText: toolTipCancellationBodyText,
      cancellationPenaltyType: cancellationPenaltyType,
      freeCancellationText: freeCancellationText,
      freeCancellation: freeCancellation,
      isFreeCancellation: isFreeCancellation,
      isPayAtHotel: isPayAtHotel,
      withTooltip: withTooltip,
      isNonRefundable: isNonRefundable,
      refundType: refundType,
      payLaterText: payLaterText,
      payLater: payLater,
      amenities: amenities,
      payAtHotel: payAtHotel,
      payAtHotelText: payAtHotelText,
      nonRefundableText: nonRefundableText,
      nonRefundable: nonRefundable,
      refundable: refundable,
      partiallyRefundableText: partiallyRefundableText,
      partiallyRefundable: partiallyRefundable,
      instantConfirmationText: instantConfirmationText,
      recommendedText: recommendedText,
      flierDiscountText: flierDiscountText,
      isSingleOption: isSingleOption,
      discountText: discountText,
      totalPrice: totalPrice,
      strikeThrough: strikeThrough,
      totalPayable: totalPayable,
      onSelectRateHandler: onSelectRateHandler,
      bigMembership: bigMembership,
      applyBigpoints: applyBigpoints,
      includeTaxText: includeTaxText,
      isSnap: isSnap,
      bigPoint: bigPoint,
      promoTitle: promoTitle,
      roomAmenity: roomAmenity,
      baseRate: baseRate,
      CTAButtonText: CTAButtonText,
      includedInPriceHeader: includedInPriceHeader,
      baseRateAfterBigPointsDeduction: baseRateAfterBigPointsDeduction,
      discountType: discountType,
      locale: locale,
      perGuestText: perGuestText,
      snapPriceText: snapPriceText,
      bedGroupsOptions: bedGroupsOptions,
      roomAmenityName: roomAmenityName,
      messageFOMO: messageFOMO,
      isSoldOut: isSoldOut,
      lowInventoryFOMO: lowInventoryFOMO,
      isBogoPromoEnabled: isBogoPromoEnabled,
      bogoMessage: bogoMessage,
      payNowMessage: payNowMessage,
      isPayNowEnabled: isPayNowEnabled && Boolean(!isPayLater && !isPayAtHotel),
      move: move,
      isRM9PromoEnabled: isRM9PromoEnabled,
      accessible: accessible
    })), /*#__PURE__*/_react.default.createElement(PriceInfoWrapper, null, /*#__PURE__*/_react.default.createElement(PriceInfo, {
      discountText: discountText,
      enableCombosavingsTag: enableCombosavingsTag,
      bundleSavingsTag: bundleSavingsTag,
      savingsAmount: savingsAmount
      // eslint-disable-next-line react/prop-types
      ,
      totalInclusivePriceValue: totalInclusivePrice === null || totalInclusivePrice === void 0 ? void 0 : totalInclusivePrice.value
      // eslint-disable-next-line react/prop-types
      ,
      totalInclusivePriceCurrency: totalInclusivePrice === null || totalInclusivePrice === void 0 ? void 0 : totalInclusivePrice.currency,
      totalSummaryPax: totalSummaryPax,
      strikeThrough: strikeThrough,
      strikethroughPrice: strikethroughPrice,
      price: bigMembership && applyBigpoints ? baseRateAfterBigPointsDeduction : price,
      totalPrice: bigMembership && applyBigpoints ? totalPayable : totalPrice,
      theme: theme,
      CTAButtonText: newTextButtonCTA,
      onSelectRateHandler: onSelectRateHandler,
      locale: locale,
      perGuestText: perGuestText,
      baseRate: baseRate,
      snapPriceText: snapPriceText,
      includeTaxText: includeTaxText,
      perNight: perNight,
      perGuest: perGuest,
      bigPoint: bigPoint,
      perPersonBaseRate: perPersonBaseRate,
      isSnap: isSnap,
      isSoldOut: isSoldOut,
      isBogoPromoEnabled: isBogoPromoEnabled,
      bogoTag: bogoTag,
      move: move,
      isRM9PromoEnabled: isRM9PromoEnabled,
      accessible: accessible,
      secondNight: secondNight,
      getTranslatedPricebreakdownData: getTranslatedPricebreakdownData,
      isMobile: isMobile,
      installmentPaymentData: installmentPaymentData,
      orText: orText,
      enableInstallmentOption: enableInstallmentOption
    }))));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
RateInfo.propTypes = _RoomCard.RateInfoPropTypes;
RateInfo.defaultProps = _RoomCard.RateInfoDefaultValues;
var _default = RateInfo;
exports.default = _default;